import { render } from "./EditPrinterModal.vue?vue&type=template&id=6a0c922f"
import script from "./EditPrinterModal.vue?vue&type=script&lang=js"
export * from "./EditPrinterModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__